<section class="page-fill rounded-2xl border border-neutral-200 bg-white">
  <app-signal-data-table
    class="page-fill-host"
    [columnDefs]="columnDefs"
    [state]="tableState"
    [pageSize]="100"
    (tableStateChanged)="onTableStateChanged($event)"
    (onActionPerformed)="onTableAction($event)" />
</section>
